module.exports = __webpack_public_path__ + "static/media/white_search_icon.e5f424fb.svg";